import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

// import './polyfill'

import { createAxiosInstances } from 'statotest-api-requests/dist/helper';
import { statotestChartAppConfig } from 'statotest-charts';

import App from './App';
import { UnauthenticatedUserProvider } from './hooks/contexts/useUserDataContext';
import store from './store';

import appConfig from 'src/config.json';

import './helpers/dayjs-init';
import { featuresFlags } from './helpers/helpers';
import './i18n';
import { initSentry } from './utils/sentry';

export const API_DOMAIN = "statotestapiv4-statotestapiv4dev.azurewebsites.net";

const init = () => {
  if (!import.meta.env.DEV) {
    // Initialize Sentry before anything else
    initSentry();
  } else { console.info("Sentry not initialized in development mode"); }

  createAxiosInstances({
    baseApiUrl: `https://${API_DOMAIN}`,
    inputApiUrl: appConfig.DIAPI_URL,
  });

  // init statotest-charts
  const appType = featuresFlags.params['statotest-charts'].appType;
  console.info("setting appType for statotest-charts: ", appType);
  statotestChartAppConfig.changeAppType(appType);
}
init();

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <UnauthenticatedUserProvider>
      <App />
    </UnauthenticatedUserProvider>
  </Provider>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
